import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

interface CategoryTabsProps {
  activeSlug?: string;
}

export default function CategoryTabs({ activeSlug }: CategoryTabsProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <Link
        to="/category/latest-entrance"
        className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
          !activeSlug || activeSlug === 'latest-entrance'
            ? 'bg-primary-500 text-background-50 font-medium'
            : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600 border border-background-200/70'
        }`}
      >
        全部
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.id}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-background-50 font-medium'
              : 'bg-background-100 text-foreground-600 hover:bg-primary-50 hover:text-primary-600 border border-background-200/70'
          }`}
        >
          <span className="flex items-center gap-1.5">
            <i className={`${cat.icon} text-xs`}></i>
            {cat.name}
          </span>
        </Link>
      ))}
    </div>
  );
}